module.exports = __webpack_public_path__ + "static/media/LightsonWonderRockJacket.918396b1.jpg";